import { Iframe } from '@components/iframe/models';
import { Block } from '@shared/models';

export const iframeMock: Block<Iframe> = {
  type: 'iframe',
  data: {
    url: 'https://www.calameo.com/read/004128602d83708700548',
  },
};
